(() => {
  if (window.tempProThanksgivingVariantsBound) return;
  window.tempProThanksgivingVariantsBound = true;
  document.addEventListener('change', event => {
    const input = event.target;
    if (!input.matches('[data-probe-selector] input[type="radio"]') || !input.checked || input.disabled) return;
    const card = input.closest('.card_item');
    card.querySelector('.sale_price').textContent = input.dataset.price;
    const compare = card.querySelector('.origin_price');
    if (compare) {
      compare.textContent = input.dataset.compare;
      compare.hidden = !input.dataset.compare;
    }
    let badge = card.querySelector('.item_reduction');
    if (!badge && Number(input.dataset.discount) > 0) {
      badge = document.createElement('div');
      badge.className = 'item_reduction';
      card.querySelector('.cardIn').prepend(badge);
    }
    if (badge) {
      badge.textContent = input.dataset.discount + '% OFF';
      badge.hidden = Number(input.dataset.discount) <= 0;
    }
    card.querySelectorAll('.product_media a, .product_title a, a.product_more').forEach(link => {
      const url = new URL(link.href, location.origin);
      url.searchParams.set('variant', input.value);
      link.href = url.toString();
    });
    if (input.dataset.image) {
      const image = card.querySelector('.product_media img');
      image.removeAttribute('srcset');
      image.src = input.dataset.image;
      image.alt = card.querySelector('.product_title').textContent.trim() + ' - ' + input.dataset.title;
    }
  });
})();
